import { Component, EventEmitter, OnInit } from '@angular/core';
import { ConfirmationDto } from '../../../../services/types';
import { McbConfirmationService } from '../../../../services/mcb-confirmation.service';

@Component({
  selector: 'mcb-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html'
})
export class PortalConfirmationDialogComponent implements OnInit {
  title: string = "تایید عملیات";
  message: string = "آیا از انجام عملیات مطمئن هستید؟";
  confirmation: ConfirmationDto;
  showDialog = false;

  constructor(private confirmationService: McbConfirmationService) {
  }

  ngOnInit() {
    this.confirmationService.confirmed.subscribe(result => {
      this.confirmation = result;
      this.title = result.title;
      this.message = result.message;
      if (this.confirmation.accept) {
        this.confirmation.acceptEvent = new EventEmitter();
        this.confirmation.acceptEvent.subscribe(this.confirmation.accept);
      }

      if (this.confirmation.reject) {
        this.confirmation.rejectEvent = new EventEmitter();
        this.confirmation.rejectEvent.subscribe(this.confirmation.reject);
      }
      this.showDialog = true;
    });
  }

  accept() {
    if (this.confirmation.acceptEvent) {
      this.confirmation.acceptEvent.emit();
    }
    this.showDialog = false;
    this.confirmation = null;
  }

  reject() {
    if (this.confirmation.rejectEvent) {
      this.confirmation.rejectEvent.emit();
    }
    this.showDialog = false;
    this.confirmation = null;
  }
}
